import { render, staticRenderFns } from "./AssetReplaceForm.vue?vue&type=template&id=021b5952&scoped=true"
import script from "./AssetReplaceForm.vue?vue&type=script&lang=js"
export * from "./AssetReplaceForm.vue?vue&type=script&lang=js"
import style0 from "./AssetReplaceForm.vue?vue&type=style&index=0&id=021b5952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021b5952",
  null
  
)

export default component.exports